import {
  PT_MASTERCATEGORY,
  PT_PRODUCT_LIST,
} from "../../../../routes/stack/paths/pt-home";
import { set_dto_Merchant } from "../../../../classes/dto-setters/dto-setter";
import { CSP } from "../../../../config/config";
import React from "react";

export default class ClickbleBanner extends React.Component {
  render() {
    let data = this.props.pmData;
    return (
      <div
        style={{ margin: 10, cursor: "pointer" }}
        className="fadeInUp animated"
        data-wow-duration="300ms"
        data-wow-delay="0ms"
        onClick={async () => {
          await this.MerchantClick(data[0]);
        }}
      >
        <img
          alt="test"
          src={data[0].BannerURL}
          style={{ width: "100%", height: 85, objectFit: "cover" }}
        />
      </div>
    );
  }
  async MerchantClick(rs) {
    rs.CATID = 0;
    await set_dto_Merchant(rs);
    if (CSP === "MK") {
      rs.MT = "GR";
    }
    if (rs.MT.toUpperCase() === "GR" || rs.MT.toUpperCase() === "AF") {
      this.props.navigate(PT_MASTERCATEGORY);
    } else {
      this.props.navigate(
        PT_PRODUCT_LIST.replace(":navPage", "home").replace(":isSec", "false")
      );
    }
  }
}
